<template>
  <footer class="footer-copyright font-label-5 text-center">
    © {{ currentYear }} Karier.mu. PT Semesta Integrasi Digital. All Rights Reserved.
  </footer>
</template>

<script>
export default {
  name: 'FooterCopyrightV2',
  computed: {
    currentYear () {
      return new Date().getFullYear()
    }
  }
}
</script>

<style lang="scss" scoped>
.footer-copyright {
  position: absolute;
  width: 100%;
  bottom: 0;
  min-height: 64px;
  padding: 24px 0;
  color: #67676F;
}
</style>
